class DocumentLanguage {
  private static readonly TRANSLATED_CLASS_NAMES: readonly string[] = ['translated-ltr', 'translated-rtl'];

  public static apply(language: string): string {
    const htmlLanguage = DocumentLanguage.resolve(language);
    const root = document.documentElement;
    root.lang = htmlLanguage;
    root.setAttribute('translate', 'no');
    root.classList.add('notranslate');
    return htmlLanguage;
  }

  public static isBrowserTranslated(): boolean {
    return DocumentLanguage.hasTranslatedClass(document.documentElement) || DocumentLanguage.hasTranslatedClass(document.body);
  }

  private static hasTranslatedClass(element: HTMLElement | null): boolean {
    if (element == undefined) {
      return false;
    }
    for (const className of DocumentLanguage.TRANSLATED_CLASS_NAMES) {
      if (element.classList.contains(className)) {
        return true;
      }
    }
    return false;
  }

  private static resolve(language: string): string {
    switch (language) {
      case 'tr-TR':
        return 'tr';
      case 'en-US':
        return 'en';
      case 'ru-RU':
        return 'ru';
      case 'uzbek':
        return 'uz';
      default:
        return language;
    }
  }
}

export default DocumentLanguage;
